import React, { Component, createRef } from 'react';
import {
  Text,
  View,
  TextInput,
  Alert,
  StyleSheet,
  ScrollView,
  Platform,
  TouchableOpacity,
} from 'react-native';
import PropTypes from 'prop-types';
import codePush from 'react-native-code-push';
import dismissKeyboard from 'react-native-dismiss-keyboard';
import { globalStyles } from 'app/styles/global';
import { colors } from 'styles';
import CustomSpinner from 'modules/ui/mobile/CustomSpinner.component';
import TwitterButton from './TwitterButton.component';
import { ConnectDesktopButton } from '../socialButtons';
import { Captcha } from 'utils/recaptcha/mobile';
import { AppleLogin } from '../apple';
import { Box } from 'modules/styled';

let styles;

class Login extends Component {
  static propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    navigation: PropTypes.object,
    share: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    this.login = this.login.bind(this);
    this.state = {
      bool: false,
      notifText: null,
      username: '',
      password: '',
      recaptcha: null,
    };
  }

  // userInput = createRef();
  reCaptchaRef = createRef();

  componentDidMount() {
    // this.userInput.focus();
    codePush.disallowRestart();
  }

  componentWillUnmount() {
    this.props.actions.setAuthStatusText();
  }

  login() {
    if (!this.state.username) {
      Alert.alert('must enter username');
      return;
    }

    if (!this.state.password) {
      Alert.alert('must enter password');
      return;
    }
    dismissKeyboard();
    this.props.actions.loginUser(
      {
        name: this.state.username,
        password: this.state.password,
        twitter: this.props.auth?.twitter,
      },
      this.state.recaptcha
    );
  }

  render() {
    const { actions } = this.props;

    let local =
      this.state.username &&
      this.state.password &&
      this.state.username.length &&
      this.state.password.length;

    if (this.props.auth?.twitter) local = true;

    const twitterConnect = (
      <View style={[{ justifyContent: 'center', alignItems: 'center' }]}>
        <Text style={styles.signInText}>
          Sign in with your Relevant account to finish
        </Text>
      </View>
    );

    const signIn = (
      <TouchableOpacity onPress={this.login} style={[styles.largeButton]}>
        <Text style={styles.largeButtonText}>sign in</Text>
      </TouchableOpacity>
    );

    if (this.props.auth?.loading) {
      return <CustomSpinner />;
    }

    return (
      <ScrollView
        keyboardShouldPersistTaps="allways"
        keyboardDismissMode="interactive"
        contentContainerStyle={styles.authScrollContent}
      >
        <View style={styles.fieldsInner}>
          <View style={styles.fieldsInputParent}>
            <TextInput
              key={'name'}
              underlineColorAndroid={'transparent'}
              autoCorrect={false}
              autoCapitalize={'none'}
              clearTextOnFocus={false}
              placeholderTextColor={colors.grey}
              placeholder="username or email"
              onChangeText={(username) => {
                this.setState({ username: username?.trim() || '' });
              }}
              onBlur={() => null}
              value={this.state.username}
              style={styles.fieldsInput}
            />
          </View>

          <View style={styles.fieldsInputParent}>
            <TextInput
              key={'pass'}
              ref={this.passInput}
              underlineColorAndroid={'transparent'}
              autoCapitalize={'none'}
              autoCorrect={false}
              secureTextEntry
              keyboardType={'default'}
              clearTextOnFocus={false}
              placeholderTextColor={colors.grey}
              placeholder="password"
              onChangeText={(password) =>
                this.setState({ password: password?.trim() || '' })
              }
              onBlur={() => null}
              value={this.state.password}
              style={styles.fieldsInput}
            />
          </View>
          {local ? null : (
            <View>
              <Text style={styles.signInText}>or</Text>
              <TwitterButton auth={this.props.auth} actions={this.props.actions} />
            </View>
          )}
          {!local && (
            <View style={{ marginTop: 21 }}>
              <ConnectDesktopButton
                text={'Sign in with Desktop Browser'}
                onPress={() => actions.showModal('connectDesktop')}
              />
            </View>
          )}
          {!local && Platform.OS === 'ios' && (
            <Box sx={{ mt: 3 }}>
              <AppleLogin isLogin />
            </Box>
          )}
          <View style={{ flex: 1 }} />
          {this.props?.auth?.twitter ? twitterConnect : null}
        </View>

        {local ? signIn : null}

        <TouchableOpacity
          onPress={() => {
            this.props.navigation.navigate({
              routeName: 'forgot',
              params: { title: 'Forgot Password' },
            });
          }}
        >
          <Text style={[styles.signInText, styles.active]}>Forgot your password?</Text>
        </TouchableOpacity>
        <Captcha
          reCaptchaRef={this.reCaptchaRef}
          action={'login'}
          setToken={(token) => this.setState({ recaptcha: token })}
        />
      </ScrollView>
    );
  }
}

Login.propTypes = {
  auth: PropTypes.object,
  actions: PropTypes.object,
  navigation: PropTypes.object,
  share: PropTypes.bool, // flag for share extension
};

const localStyles = StyleSheet.create({
  forgot: {
    textAlign: 'center',
    marginTop: 5,
  },
});
styles = { ...localStyles, ...globalStyles };

export default Login;
